import { gql } from "@apollo/client";

export const bulkPatchRemoteAssetsMutation = gql`
    mutation bulkPatchRemoteAssets($organizationId: ID!, $assetIds: [ID!]!, $forkingAllowed: Boolean!) {
        bulkPatchRemoteAssets(
            input: { organizationId: $organizationId, assetIds: $assetIds, forkingAllowed: $forkingAllowed }
        ) {
            results {
                assetId
                error {
                    code
                    message
                }
            }
        }
    }
`;
